import styled from '@emotion/styled'

import { Color } from '@/utils'

const ScrollerContainer = styled.div`
  display: flex;
  width: ${({ width }) => width};
  min-height: ${({ $minHeight }) => $minHeight};
  max-height: ${({ $maxHeight }) => $maxHeight};
  flex-grow: ${({ $flexGrow }) => $flexGrow};
  border-style: solid;
  border-color: ${({ $borderColor }) => $borderColor};
  border-width: ${({ $borderWidth }) => $borderWidth};
  border-radius: 4px;
  overflow: ${({ $outerOverflowHidden }) => $outerOverflowHidden && 'hidden'};
  padding: ${({ $outerPadding }) => $outerPadding};
`

const ScrollerElement = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: ${({ $maxHeight }) => $maxHeight};
  height: ${({ height }) => height};

  overflow-x: ${({ $overflowX }) => $overflowX};
  overflow-y: ${({ $overflowY }) => $overflowY};
  padding: ${({ padding }) => padding};
  margin: 0;

  ::-webkit-scrollbar {
    width: ${({ $thumbWidth }) => ($thumbWidth === 'small' ? '4px' : '6px')};
    height: ${({ $thumbWidth }) => ($thumbWidth === 'small' ? '4px' : '6px')};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ variant }) =>
    variant === 'secondary' ? Color.textDisabled : Color.white};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${Color.primary};
    border-radius: 10px;
  }

  // Firefox style
  scrollbar-color: ${Color.primary}
    ${({ variant }) =>
    variant === 'secondary' ? Color.textDisabled : Color.white};
  scrollbar-width: ${({ $thumbWidth }) =>
    $thumbWidth === 'small' ? 'thin' : 'auto'};
`

const Scroller = ({
 width = '100%',
 height = '100%',
 $minHeight = '0',
 $maxHeight = '100%',
 $borderColor = Color.lightGray,
 $borderWidth = '1px',
 $overflowX = 'auto',
 $overflowY = 'auto',
 $thumbWidth,
 $flexGrow,
 variant,
 padding = '20px 16px 20px 20px',
 $outerPadding,
 $outerOverflowHidden = true,
 $onScroll,
 children,
}) => (
    <ScrollerContainer
        width={width}
        height={height}
        $maxHeight={$maxHeight}
        $minHeight={$minHeight}
        $flexGrow={$flexGrow}
        $borderColor={$borderColor}
        $borderWidth={$borderWidth}
        $outerOverflowHidden={$outerOverflowHidden}
        $outerPadding={$outerPadding}
    >
        <ScrollerElement
            width="100%"
            $overflowX={$overflowX}
            $overflowY={$overflowY}
            padding={padding}
            $thumbWidth={$thumbWidth}
            variant={variant}
            $onScroll={$onScroll}
        >
            {children}
        </ScrollerElement>
    </ScrollerContainer>
)

export { Scroller }
